import React from 'react'
import { Box } from '@radix-ui/themes'
import Skeleton from 'react-loading-skeleton'
import styles from './bulls-eye-game-skeleton.module.scss'

export const BullsEyeGameGraphSkeleton: React.FC = () => {
  return (
    <Box className={styles.panel}>
      <Skeleton
        width={'100%'}
        height={'52rem'}
        borderRadius={'2rem'}
      />
    </Box>
  )
}
